import { Box, Typography, Grid, Link } from '@mui/material';
import brandLogo from '../assets/images/brand-logo.png';

const Footer = () => (
  <Box sx={{ px: {xs: 4, md: 20}, py: {xs:4, md: 12}, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: {xs: 'column', md: 'row'}, borderBottom: {xs: '8px solid #6D9A5B', md: 'none'} }}>
      <Box>
        <img src={brandLogo} width="100%" style={{ marginBottom: "40px"}}/>
        <Typography sx={{ display: {xs: 'none', md: 'block'}}} variant="body1">© 2024 Vivek Bio Products Pvt. Ltd.</Typography>
        <Typography sx={{ display: {xs: 'none', md: 'block'}}} variant="body1">All rights reserved.</Typography>
      </Box>
      <Box>
        <Typography sx={{ textAlign: {xs: 'center', md: 'left'}}} variant="body1" fontWeight="bold" marginBottom={2} gutterBottom>Quick Links</Typography>
        <Box sx={{ display: {xs: 'flex', md: 'block'}, justifyContent: 'center', gap: '20px', mb:{xs: 4, md: 0} }}>
        <Typography variant="body1" marginBottom={1} >
          <Link sx={{color: 'inherit', textDecoration: 'none'}} href="/home">Home</Link>
        </Typography>
        <Typography variant="body1" marginBottom={1} >
          <Link sx={{color: 'inherit', textDecoration: 'none'}} href="/about">About</Link>
        </Typography>
        <Typography variant="body1" marginBottom={1} >
          <Link sx={{color: 'inherit', textDecoration: 'none'}} href="/products">Products</Link>
        </Typography>
        <Typography sx={{ display:{ xs: 'block', md: "none"}}} variant="body1" marginBottom={1} >
          <Link sx={{color: 'inherit', textDecoration: 'none'}} href="/contact">Contact</Link>
        </Typography>
        </Box>
        <Typography variant="body1" sx={{display: 'flex', gap: '50px', alignItems: 'center'}}>
          <Typography sx={{ display:{ xs: 'none', md: "block"}, width: "60%"}} variant="body1" >
            <Link sx={{color: 'inherit', textDecoration: 'none', }} href="/contact">Contact Us</Link>
          </Typography>
          <Box sx={{ display: 'flex', gap: "10px", alignItems: "center", justifyContent: 'center', width: '100%'}}>
            <iconify-icon icon="ic:baseline-facebook" width="24" height="24" ></iconify-icon>
            <iconify-icon icon="mdi:instagram" width="24" height="24" ></iconify-icon>
            <iconify-icon icon="prime:twitter" width="14" height="14"></iconify-icon>
            <iconify-icon icon="uil:linkedin" width="24" height="24"></iconify-icon>
            <iconify-icon icon="mdi:youtube" width="24" height="24"></iconify-icon>
          </Box>
        </Typography>
        <Box sx={{ display: {xs: 'block', md: 'none'}, mt: 2}}>
        <Typography variant="body1">© 2024 Vivek Bio Products Pvt. Ltd. &nbsp;</Typography>
        <Typography variant="body1">All rights reserved.</Typography>
      </Box>
      </Box>
  </Box>
);

export default Footer;
